export const ADD_TODO = 'ADD_TODO';
export const REMOVE_TODO = 'REMOVE_TODO';
export const TOGGLE_COMPLETE = 'TOGGLE_COMPLETE';
export const CLEAR_COMPLETE = 'CLEAR_COMPLETE';
export const ORDER_TODO = 'ORDER_TODO';

export const CHANGE_STATUS = 'CHANGE_STATUS';
